<template>
	<DjCard
		v-if="!loading"
		class="flex justify-between bg-white px-5 py-6 sm:px-12 sm:py-10 w-full max-w-[600px] h-full"
	>
		<div class="relative mb-6 sm:mb-20">
			<p class="relative font-zillaslab italic text-left text-lg sm:text-2xl z-10">
				{{ mainText }}
			</p>
			<img
				class="absolute right-0 -bottom-4 w-10 sm:w-auto sm:-bottom-12"
				src="https://res.cloudinary.com/djbs/image/upload/v1652880191/content/DreamJobs/Graphics/icon_quote.svg"
				:alt="'Quote'"
			/>
		</div>
		<div class="flex flex-row">
			<img
				class="relative w-14 h-14 sm:w-dj-80 sm:h-dj-80 rounded-full mr-3 sm:mr-5"
				:src="photoUrl"
				:alt="`Photo ${fullName}`"
			/>
			<div class="flex flex-col justify-center items-start">
				<span class="text-base sm:text-lg text-left font-medium leading-5 sm:leading-6">{{ fullName }}</span>
				<div class="text-xs sm:text-sm font-normal text-dj-grey text-left mt-0.5 sm:mt-0">
					<span class="block">{{ companyName }}</span>
					<span v-if="position" class="block">{{ position }}</span>
				</div>
			</div>
		</div>
	</DjCard>

	<DjCard v-else class="bg-white px-5 py-6 sm:px-12 sm:py-10 border-dj-light-blue animate-pulse">
		<div class="relative mb-6 sm:mb-20">
			<div
				v-for="(item, index) in 7"
				:key="index"
				class="relative w-full h-4 sm:h-6 mb-2 my-auto flex rounded-lg bg-dj-gray-minimal z-10"
			></div>
			<div class="relative w-full h-4 sm:h-6 my-auto flex rounded-lg bg-dj-gray-minimal z-10"></div>
			<img
				class="absolute right-0 -bottom-4 w-10 sm:w-auto sm:-bottom-12"
				src="https://res.cloudinary.com/djbs/image/upload/v1652880191/content/DreamJobs/Graphics/icon_quote.svg"
				:alt="'Quote'"
			/>
		</div>
		<div class="flex flex-row mt-2">
			<div class="relative w-14 h-14 sm:w-dj-80 sm:h-dj-80 rounded-full mr-3 sm:mr-5 bg-dj-gray-minimal"></div>
			<div class="w-1/2 flex flex-col justify-center items-start">
				<div class="w-full h-4 mb-1 my-auto flex rounded-lg bg-dj-gray-minimal"></div>
				<div class="w-full h-3 mb-0.5 my-auto flex rounded-lg bg-dj-gray-minimal"></div>
				<div class="w-full h-3 my-auto flex rounded-lg bg-dj-gray-minimal"></div>
			</div>
		</div>
	</DjCard>
</template>

<script lang="ts">
import DjCard from "./DjCard.vue";

import { defineComponent } from "vue";

export default defineComponent({
	name: "DjCardTestimonial",
	components: {
		DjCard,
	},
	props: {
		mainText: {
			type: String,
			default: "",
			required: true,
		},
		fullName: {
			type: String,
			default: "",
			required: true,
		},
		companyName: {
			type: String,
			default: "",
		},
		position: {
			type: String,
			default: "",
		},
		photoUrl: {
			type: String,
			default: "",
		},
		loading: {
			type: Boolean,
			default: false,
		},
	},
});
</script>
